import { render, staticRenderFns } from "./CourseHeader.vue?vue&type=template&id=bc03b73c&scoped=true"
import script from "./CourseHeader.vue?vue&type=script&lang=js"
export * from "./CourseHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc03b73c",
  null
  
)

export default component.exports